import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { viewCollectionsList } from "../../Redux/Actions/collectionsActions";
import { columnsSubCollections } from "../../Global Functions/columnsAntd";
import TableComponent from "../../Global Functions/tableComponents";

const ViewCollections = () => {
  const dispatch = useDispatch();

  const { id: fetchedId } = useParams();

  const [foundCollection, setFoundCollection] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const fetchDetails = useCallback(
    (page, limit) => {
      const subCollectionData = {
        page,
        limit,
        collection_id: fetchedId,
        filter: searchQuery,
      };
      dispatch(viewCollectionsList(subCollectionData));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [fetchedId, dispatch]
  );

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
  }, [pagination, fetchDetails]);

  const { collections, subCollections } = useSelector(
    (state) => state.collections || {}
  );

  useEffect(() => {
    if (collections?.total) {
      setPagination((prevData) => ({ ...prevData, total: collections.total }));
    }
  }, [collections]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
    fetchDetails(pagination.current, pagination.pageSize);
  };

  useEffect(() => {
    const foundCollection = subCollections?.data
      ? subCollections.data.find(
        (collection) => String(collection._id) === String(fetchedId)
      )
      : [];
    setFoundCollection(foundCollection);
  }, [subCollections, fetchedId]);

  const filterHandler = () => {
    setPagination((prevData) => ({ ...prevData, current: 1 }));
    fetchDetails(1, pagination.pageSize);
  };

  return (
    <TableComponent
      h3heading={foundCollection?.name || "No Data"}
      buttonhead={canAdd ? "Add Sub Collection" : null}
      setState={setSearchQuery}
      filterFunction={filterHandler}
      navigateTo={canAdd ? `/collections/${fetchedId}/sub/add` : null}
      buttonhead2="Back To Collections"
      navigateTo2="/collections"
      rowKey="_id"
      pagination={pagination}
      onChange={handleTableChange}
      columns={columnsSubCollections(canEdit)}
      dataSource={
        Array.isArray(subCollections?.data) ? subCollections.data : []
      }
    ></TableComponent>
  );
};

export default ViewCollections;
